import { gql } from "@apollo/client";

export const UPSERT_INPUT_ATTRIBUTION_OPTIONS = gql`
  mutation UpdateInputAttributionOptions(
    $attributionModels: [AttributionModelInput!]!
    $attributionWindows: [AttributionWindowInput!]!
  ) {
    updateInputAttributionModelOptions(attributionModels: $attributionModels) {
      message
    }
    updateInputAttributionWindowOptions(
      attributionWindows: $attributionWindows
    ) {
      message
    }
  }
`;
